import {Button,Card,ConfigProvider,Form,Input,InputNumber,message,Modal,Skeleton,Spin,Typography} from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { GroupGrid } from "./GroupGrid";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
const { Title } = Typography;
import {
  FilterOutlined,
   } from "@ant-design/icons";

const ElectricalGroups = () => {
  const {loading, makeRequest } = useStoreUpdaterWithAPI();
  const [row, setRow] = useState([]);
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode; 
  const [refetch, setRefetch] = useState(true);
  const [open, setOpen] = useState(false);
  const [loadings, setLoadings] = useState(true);
  const simulateLoading = (setLoadings) => {
    setLoadings(true);
    setTimeout(() => {
      setLoadings(false);
    }, 2000); 
  };
  
  useEffect(() => {
    simulateLoading(setLoadings);
  }, []);

  const handleOk = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };


  const getConverter = (formValues) => {
    console.log(formValues);
    // http://20.244.40.160:92/GetConverterDetails?ConverterName=as&ConverterID=1
    const url = `${APIConstants.ELECTRICAL_GROUP_DETAILS}?Module=1`;
    console.log(url);

    setLoadings(true)
    makeRequest({
      type: APIConstants.POST,
      url: url,
      // body:formValues
    }).then((res) => {
      console.log(res);
      if(res){
        setRow(res);
        setLoadings(false)
      }
    });
  };
  useEffect(() => {
    getConverter();
  }, [refetch]);

  const handleNotification = (msg, type) => {
    message.open({
      content: `${msg}`,
      type: type,
    });
  };

  const handleAddPopup = () => {
    console.log("pop open");
    setOpen(true);
  };
  console.log(loading)
  console.log(loadings)
  const color = useSelector((state) => state.ThemeChange);
  console.log(color)

  return ( 
    <div>
       <div className="flex justify-between items-center px-0 pb-4">
        <div className="text-3xl">
       <h4 className={`text-center text-[20px] mb-5 dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>GROUP</h4>
        </div>
          <Button
            role="primary"
            size="large"
            className="flex justify-center items-center secondary-btn"
            style={{ "--secondary-color": color.themeConfig.secondaryColor,"--primary-color": color.themeConfig.colorPrimary }}
            onClick={() => setOpen(!open)}
          >
            <FilterOutlined /> Filter
          </Button>
      </div>
      <Card 
        className={`w-full h-auto dark ${!isdarkMode ? "bg-slate-50 border-0" : "bg-slate-900"} `}
      >
        
        {/* <div className="flex text-xl justify-center ">
          <p className={`${isdarkMode? 'text-white':'text-black'}  pb-1`} >
          Group 
          </p>
        </div> */}
        <div className="flex justify-end mt-2">

                      <Button
            type= {isdarkMode? "":'primary'}
            onClick={handleAddPopup}
            className=" mb-2"
          >
            Add Group
          </Button>
        
        </div>

        <GroupPopup
          handleOk={handleOk}
          handleCancel={handleCancel}
          open={open}
          handleNotification={handleNotification}
          refetch={refetch}
          setRefetch={setRefetch}
        />

          {
            !loadings?( 
        <div
         className={`${isdarkMode ? "ag-theme-alpine" : "ag-theme-quartz"}`}
        style={{
          '--ag-header-background-color': color.themeConfig.colorPrimary, 
          '--ag-header-foreground-color': '#fff', 
          height: "80vh", width: "100%", overflowY: "auto" 
        }}
        >
          <Spin indicator={<Spin size="large" />} spinning={false}>
            <GroupGrid
              row={row}
              refetch={refetch}
              setRefetch={setRefetch}
              // className={`${isdarkMode ? "ag-theme-alpine" : "ag-theme-quartzs"}`}
              handleNotification={handleNotification}
            />
          </Spin>
        </div>

            ):(
              <Skeleton active paragraph={{ rows: 6 }} />
            )
          }
      </Card>
    </div>
  );
};

export default ElectricalGroups;

const GroupPopup = ({
  handleOk,
  handleCancel, 
  open,
  loading,
  handleNotification, 
  refetch,
  setRefetch,
}) => {
  console.log(open);
  const [form] = Form.useForm();
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const { makeRequest } = useStoreUpdaterWithAPI();

  // State to hold form values
  const [formValues, setFormValues] = useState({});

  // Handle form submission
  const onFinish = (values) => {
    setFormValues(values);
    form.resetFields()
    console.log(values); // Log the form values
    handleOk();
    insertGroup(values);
  };

  const insertGroup = (formValues) => {
    console.log(formValues);
    const url = `${APIConstants.ELECTRICAL_INSERT_GROUP}`;
    console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url, 
      body: formValues,
    }).then((res) => {
      setRefetch(!refetch);
      handleNotification(res.message, "success");
      console.log(res.message);
    });
  };
     const color = useSelector((state) => state.ThemeChange);
      console.log(color)

  return (
    <Modal 
      open={open}
      onOk={handleOk} 
      onCancel={handleCancel} 
      footer={null}
      className={`custom-modal  ${isdarkMode ? " group-custom-modal-dark  group-custom-modal-header group-labels group-input group-select-input-background " : "whitemode"} `}
    >
      {/* Custom full-width header */}
      <div className="modal-header mb-3 px-4 py-3  rounded-t-lg" 
      style={{ backgroundColor: color.themeConfig.colorPrimary }}>
        <Title level={4} style={{ margin: 0, color: "white" }}>
          Add Group
        </Title>
      </div>

      {/* Form Content */}
      <div className=" px-4 pb-3">
        <Form
        form={form}
          name="Group-add-form"
          className="font-bold"
          layout="horizontal"
          style={{ maxWidth: 600 }}
          labelCol={{ span: 8, offset: 0 }}
          labelAlign="left"
          onFinish={onFinish}
        >
          <Form.Item
            label="Group"
            name="department"
            rules={[{ required: true, message: "Please input department!" }]}
          >
            <Input className="ml-0" />
          </Form.Item>

          <Form.Item
            label="Group ID"
            name="groupID"
            rules={[{ required: true, message: "Please input Group ID!" }]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item> 

          <Form.Item wrapperCol={{ offset: 16, span: 16 }}>
            <Button key="back" className="mr-3" onClick={handleCancel}>
              Cancel
            </Button>
            <Button htmlType="submit" type='primary' loading={loading} >
              Save
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};
